// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import TranslationOfTextContentModel from '../../model/translation-of-text-content-model';
import TranslationOfTextContentDTO from '../dto/translation-of-text-content-dto';
import dtoSchema from '../schemas/translation-of-text-content-schema';

export default abstract class TranslationOfTextContentModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<TranslationOfTextContentDTO>) {
    super();
    if (data) {
      this.translatedContent = data.translatedContent ?? undefined;
      this.language = data.language ?? undefined;
    }
  }
  /**
  */
  translatedContent?: string;
  /**
  */
  language?: string;

  static toModel(dto: DeepPartial<TranslationOfTextContentDTO>): TranslationOfTextContentModel;
  static toModel(dto: DeepPartial<TranslationOfTextContentDTO> | undefined | null): TranslationOfTextContentModel | undefined;
  static toModel(dto: DeepPartial<TranslationOfTextContentDTO> | undefined | null): TranslationOfTextContentModel | undefined {
    return dto ? new TranslationOfTextContentModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<TranslationOfTextContentModel> | TranslationOfTextContentModel): TranslationOfTextContentDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      translatedContent: unwrapped.translatedContent,
      language: unwrapped.language,
    } as TranslationOfTextContentDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for TranslationOfTextContentModel, can not map to TranslationOfTextContentDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
